module.exports = __webpack_public_path__ + "assets/img/discernment_gender_scene1.3ab0d537.png";